/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Cell_Inherited_EnabledInputs */



/**
* | output |
* | --- |
* | "Organization default · enabled" |
*
* @param {Rights_Tools_Cell_Inherited_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_cell_inherited_enabled = /** @type {((inputs?: Rights_Tools_Cell_Inherited_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Cell_Inherited_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisationsstandard · aktiviert")
	return /** @type {LocalizedString} */ ("Organization default · enabled")
});